import constants from "../constants";
import { log, Source, error } from "./logger";
import { isOnProtectedPage } from "./uri";

let updateReloadTimer: number | null = null;

export function tryUpdateReload(retryLimit = 3) {
    try {
        const defaultRetryTimeout = constants.SERVICE_WORKER_UPDATE_RETRY_TIMEOUT;
        log(Source.SERVWORKER, `Checking if safe to reload. retryLimit=${ retryLimit } retryTimeout=${ defaultRetryTimeout }.`);
        const isUserOnProtectedPage = isOnProtectedPage();

        // Check if user is on a protected page (login, workflow, inspection)
        if (isUserOnProtectedPage && retryLimit > 0) {
            log(Source.SERVWORKER, `User is on a protected page. Delaying reload and checking again in ${ defaultRetryTimeout }ms.`);
            updateReloadTimer && clearTimeout(updateReloadTimer);
            updateReloadTimer = setTimeout(() => tryUpdateReload(retryLimit - 1), defaultRetryTimeout);
            return;
        }

        if (isUserOnProtectedPage) {
            log(Source.SERVWORKER, "User is still on a protected page after retries. Proceeding with force reload to apply updates...");
        } else {
            log(Source.SERVWORKER, "User is not on a protected page. Auto-reloading to apply updates...");
        }
        window.location.reload();
    } catch (err2) {
        error(Source.SERVWORKER, `Failed to check page status. Reloading now to avoid using an outdated version. error=${ err2 }`);
        window.location.reload();
    }
}